import type { AttachmentFile } from 'owa-attachment-file-types';
import type { DragData } from 'owa-dnd/lib/utils/dragDataUtil';

export interface AttachmentDragData extends DragData {
    attachmentFile: AttachmentFile;
    dragSource?: AttachmentDragDataSource;
}

export enum AttachmentDragDataSource {
    FilesFolderTree,
}
